import React, { DragEvent, useEffect, useRef, useState } from 'react';

import { Button } from 'react-bootstrap';
import ExternalContent from '../../components/externalContent';
import { externalContentConfig } from '../../redux/slices/externalContent/externalContentConfig';
import toast, { Toaster } from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslate } from '@tolgee/react';
import { addDraggedFiles } from '../../redux/slices/externalContent/externalContent';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { MAIN_COLOR_CODES, PRIMARY_DARK } from '../../config/constants';
import { faCloudArrowUp } from '@fortawesome/pro-duotone-svg-icons';
import { SUGGESTAPOSTVIEW } from '../../components/externalContent/utils/constant';
import { useParams } from 'react-router-dom';
import { getLocationDetails } from '../../redux/slices/location/locationDetails';

interface Props {}

export interface externalContentRootState {
  externalContent: {
    ui: any;
    lomavisCreatorConfig: externalContentConfig;
    externalContentConfig: any;
    platformEnabled: Record<string, boolean>;
    postTypeSelected: Record<string, string>;
    locationUuid: string | null;
    cloudUuid: string | null;
    mediaFiles: [];
    draggedMediaFiles: [];
    mediaFilesUploading: [];
    featuresEnabled: Record<string, boolean>;
    time: any;
    timeZone: any;
    is_multipost: boolean;
    recurrence_as_str: string;
    is_recurring_post: boolean;
    publication_delay_in_minutes: number;
    useSeparateMediaFiles: boolean;
    useSeparateTextFields: boolean;
    use_separate_publication_datetime: boolean;
    uploadedImageThumbnail: any;
    assetUploading: boolean;
    currentView: string;
    uploadCancelToken: any;

    postData: Record<
      string,
      Record<string, string | number | boolean | any | [] | any[]>
    >;

    allowEditorClose: boolean;
    allowMultiImageEditor: boolean;
  };
  // Add other slices of state here as needed
}
const ExternalContentCollector: React.FC<Props> = () => {
  const { t } = useTranslate();
  const dispatch = useDispatch();
  const sortableListRef = useRef(null);
  const { locationslug } = useParams();
  useEffect(() => {
    if (locationslug) dispatch(getLocationDetails(locationslug) as any);
  }, [locationslug, dispatch]);
  useEffect(() => {
    // adjust root classes to fill up 100% of the screen. Other pages could be affected by a global change,
    // so we only do it here
    const root = document.getElementById('root');
    root.classList.add('h-100', 'd-flex', 'flex-column');
  });

  // Public content collection page: hide app chrome that is irrelevant or
  // misleading for non-logged-in contributors (Login button, location-slug
  // toolbar, support chat widget). Restore on unmount so navigating back
  // into the authenticated app shows the normal layout again.
  useEffect(() => {
    document.body.classList.add('public-content-submission');
    const styleEl = document.createElement('style');
    styleEl.id = 'content-submission-chrome-overrides';
    styleEl.textContent = `
      body.public-content-submission #kt_app_header .app-navbar,
      body.public-content-submission #kt_app_toolbar,
      body.public-content-submission .bb-feedback-button,
      body.public-content-submission .grecaptcha-badge {
        display: none !important;
      }
      body.public-content-submission #kt_app_header {
        padding-top: 0.75rem !important;
        padding-bottom: 0.75rem !important;
      }
    `;
    document.head.appendChild(styleEl);
    return () => {
      document.body.classList.remove('public-content-submission');
      styleEl.remove();
    };
  }, []);

  const navBarHeight =
    document.getElementById('kt_app_header')?.clientHeight + 15 * 2 + 50;

  console.log('navbar height', navBarHeight);
  const postData = useSelector(
    (state: externalContentRootState) => state.externalContent.postData
  );
  const currentView = useSelector(
    (state: externalContentRootState) => state.externalContent.currentView
  );

  const [dragIsOver, setDragIsOver] = useState(false);
  const [items, setItems] = useState([]);

  // Define the event handlers
  const handleDragOver = (event: DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    if (
      sortableListRef.current &&
      sortableListRef.current.contains(event.target)
    ) {
      return;
    }

    setDragIsOver(true);
  };

  const handleDragLeave = (event: DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    setDragIsOver(false);
  };

  const handleDrop = (event: DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    setDragIsOver(false);

    console.log('Post data media length', postData.media?.length);

    const files = Array.from(event.dataTransfer.files);

    const allowedTypes = [
      'image/jpeg',
      'image/png',
      'image/jpg',
      'image/heic',
      'video/mov',
      'video/mp4',
      'application/pdf'
    ]; // Define allowed file types

    const filteredFiles = files.filter((file) =>
      allowedTypes.includes(file.type)
    );

    if (
      Array.isArray(postData.media) &&
      postData.media?.length + postData.mediaUploading?.length < 10
    ) {
      filteredFiles.map((item) => {
        setItems([...items, item]);
      });

      const currentCount =
        10 - (postData.media?.length + postData.mediaUploading?.length);
      currentCount > -1
        ? handleUpload(filteredFiles.slice(0, currentCount))
        : toast.error(`${t('externalContent.errors.max_limit_reached')}`, {
            duration: 4000,
            position: 'top-right'
          });
    } else {
      toast.error(`${t('externalContent.errors.max_limit_reached')}`, {
        duration: 4000,
        position: 'top-right'
      });

      console.error(
        `Maximum limit (${10}) reached!`,
        postData.media?.length,
        items?.length < 4
      );
    }
  };

  const handleUpload = (filteredFiles: any[]) => {
    dispatch(
      addDraggedFiles({
        files: filteredFiles
      })
    );
  };
  return (
    <div
      className={'d-flex flex-column h-100 mh-100 overflow-hidden'}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={(event) => {
        event.preventDefault();
        setDragIsOver(false);
      }}
    >
      {' '}
      {dragIsOver && currentView === SUGGESTAPOSTVIEW && (
        <div
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
          onDrop={handleDrop}
          style={{
            width: '100vh',
            height: '100wh',
            zIndex: 110,
            top: '1px',
            left: '1px',

            backgroundColor: 'rgba(255, 255, 255, 0.9)'
          }}
          className="underlay position-absolute w-100 h-100 d-flex justify-content-center justify-content-center "
        >
          <div
            style={{
              width: '100%',
              height: '200px',
              top: '50%',
              transform: 'translateY(-50%)',
              textAlign: 'center',
              position: 'relative',
              zIndex: 1 // Ensure text is on top of the semi-transparent background
            }}
            className="text-dark d-flex flex-column gap-3"
          >
            <i
              className="fa-solid fa-cloud-arrow-up"
              style={{
                color: MAIN_COLOR_CODES[PRIMARY_DARK],
                fontSize: '9rem'
              }}
            ></i>
            <p
              style={{ color: MAIN_COLOR_CODES[PRIMARY_DARK] }}
              className="fs-1 fw-bold"
            >
              {t('externalContent.text.drop_files_here')}
            </p>
            <p
              style={{ color: MAIN_COLOR_CODES[PRIMARY_DARK] }}
              className="fw-bolder"
            >
              {t('externalContent.text.max_10_files')}
            </p>
          </div>
        </div>
      )}
      <div
        className={
          'd-flex flex-row overflow-hidden justify-content-center align-items-center container'
        }
        style={{
          height: `100%`,

          top: `${navBarHeight}px`,

          width: '100%'
        }}
      >
        <div className={'d-flex h-100 w-100'}>
          {' '}
          <ExternalContent sortableListRef={sortableListRef} />
        </div>
      </div>
    </div>
  );
};

export default ExternalContentCollector;
